function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { BannerReact } from 'common/components/banner';
import { ActionEvent, BannerAction, BannerTheme, BannerType } from 'common/components/banner/types';
import { ButtonTheme } from 'common/components/button/constants';
import { useTranslation } from 'common/i18n/hooks';
import { useExperimentPageContext } from 'apps/experiments/src/components/context';
import { StatisticallySignificant } from 'apps/experiments/src/types';
import { useFlattenedMetricResults } from 'apps/experiments/src/components/hooks/metric-results';
import { TranslationKey } from 'common/i18n';
import { ExperimentPageBannerDecideModal } from './_decide-modal';
export function ExperimentPageBannerReview() {
  const [open, setOpen] = React.useState(false);
  const {
    canEdit
  } = useExperimentPageContext();
  const {
    t
  } = useTranslation();
  const flattenedMetricResults = useFlattenedMetricResults();
  const statsigSummary = flattenedMetricResults.reduce((summary, metricResult) => {
    switch (metricResult.statisticallySignificant) {
      case StatisticallySignificant.YES_POSITIVE:
        return _objectSpread(_objectSpread({}, summary), {}, {
          up: summary.up + 1
        });
      case StatisticallySignificant.YES_NEGATIVE:
        return _objectSpread(_objectSpread({}, summary), {}, {
          down: summary.down + 1
        });
      default:
        return summary;
    }
  }, {
    up: 0,
    down: 0
  });
  const bodyKeyPart = (count: number, key: string) => {
    if (count > 1) {
      return "-".concat(key, "-plural");
    } else if (count === 1) {
      return "-".concat(key);
    }
    return "";
  };
  const bodyKey = "experiments.banner.review.body".concat(bodyKeyPart(statsigSummary.up, "up")).concat(bodyKeyPart(statsigSummary.down, "down")) as TranslationKey;
  const bodyText = t(bodyKey, statsigSummary);
  return <>
      <BannerReact headerText={t("experiments.banner.review.title")} bodyText={bodyText} theme={BannerTheme.InfoBlue} type={BannerType.Embedded} icon='experiment' ctas={canEdit ? [{
      actionName: BannerAction.Custom,
      text: t("experiments.banner.review.cta"),
      theme: ButtonTheme.Primary
    }] : []} onAction={(ev: ActionEvent) => {
      if (ev.detail.actionName === BannerAction.Custom) {
        setOpen(true);
      }
    }} data-sentry-element="BannerReact" data-sentry-source-file="_review.tsx" />
      {open && <ExperimentPageBannerDecideModal onClose={() => setOpen(false)} />}
    </>;
}